// Account Application Form JavaScript
class AccountApplicationForm {
  constructor() {
    this.form = document.querySelector('.account-application__form');
    this.submitButton = document.querySelector('.account-application__button');
    
    // Validation patterns
    this.patterns = {
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      phone: /^[\+]?[1-9][\d]{0,15}$/,
      url: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
      ein: /^\d{2}-\d{7}$/,
      zip: /^\d{5}(-\d{4})?$/,
      year: /^(19|20)\d{2}$/,
    };

    // Error messages
    this.errorMessages = {
      required: "Value is required",
      email: "Please enter a valid email address",
      phone: "Please enter a valid phone number", 
      url: "Please enter a valid website URL",
      ein: "Please enter a valid EIN format (XX-XXXXXXX)",
      zip: "Please enter a valid ZIP code",
      year: "Please enter a valid year",
      minNumber: "Value must be at least 1",
    };

    this.init();
  }

  init() {
    if (!this.form) return;
    this.setupValidation();
    this.setupSubmitHandler();
  }

  setupValidation() {
    const inputs = this.form.querySelectorAll('.account-application__input, .account-application__checkbox');
    inputs.forEach(input => {
      input.addEventListener('blur', () => this.validateField(input));
      input.addEventListener('input', () => this.clearFieldError(input));
    });
  }

  setupSubmitHandler() {
    // NUEVA SOLUCIÓN SIMPLE INTEGRADA
    this.submitButton.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Buscar TODOS los inputs con required
      const requiredInputs = this.form.querySelectorAll('input[required]');
      
      requiredInputs.forEach(input => {
        const errorMsg = document.getElementById(`${input.id}-error`);
        
        if (input.value.trim() === '') {
          // Input VACÍO = mostrar error (quitar hidden)
          if (errorMsg) {
            errorMsg.classList.remove('hidden');
          }
        } else {
          // Input CON VALOR = validar y ocultar si es válido
          if (this.isValidInput(input)) {
            if (errorMsg) {
              errorMsg.classList.add('hidden');
            }
          } else {
            // Input con valor INVÁLIDO = mostrar error
            if (errorMsg) {
              errorMsg.classList.remove('hidden');
            }
          }
        }
      });
      
      // Si todo está válido, permitir envío
      if (this.validateForm()) {
        this.setLoadingState(true);
        this.form.submit();
      } else {
        this.scrollToFirstError();
      }
    });
  }

  // NUEVA FUNCIÓN SIMPLE DE VALIDACIÓN
  isValidInput(input) {
    const value = input.value.trim();
    const type = input.type;
    const fieldName = input.name;

    switch (type) {
      case 'email':
        return this.patterns.email.test(value);
      case 'tel':
        return this.patterns.phone.test(value.replace(/\s/g, ''));
      case 'url':
        return this.patterns.url.test(value);
      case 'number':
        return parseInt(value) >= 1;
      default:
        // Handle special field name validations
        if (fieldName && fieldName.includes('ein')) {
          return this.patterns.ein.test(value);
        }
        if (fieldName && fieldName.includes('zip')) {
          return this.patterns.zip.test(value);
        }
        if (fieldName && fieldName.includes('year_established')) {
          return this.patterns.year.test(value);
        }
        return value.length > 0;
    }
  }

  validateField(field) {
    const fieldContainer = field.closest('.account-application__field');
    const isValid = this.isFieldValid(field);

    if (!isValid) {
      fieldContainer?.classList.add('has-error');
      this.showFieldError(field);
    } else {
      fieldContainer?.classList.remove('has-error');
      this.clearFieldError(field);
    }

    return isValid;
  }

  isFieldValid(field) {
    const value = field.value.trim();
    const type = field.type;
    const required = field.hasAttribute('required');
    const fieldName = field.name;

    // Check required fields first
    if (required && !value) return false;
    
    // Skip validation if field is empty and not required
    if (!value && !required) return true;

    switch (type) {
      case 'email':
        return this.patterns.email.test(value);
      
      case 'tel':
        return this.patterns.phone.test(value.replace(/\s/g, ''));
      
      case 'url':
        return this.patterns.url.test(value);
      
      case 'number':
        return parseInt(value) >= 1;
      
      default:
        // Handle special field name validations
        return this.validateSpecialFields(fieldName, value);
    }
  }

  validateSpecialFields(fieldName, value) {
    if (!fieldName || !value) return true;

    switch (true) {
      case fieldName.includes('ein'):
        return this.patterns.ein.test(value);
      
      case fieldName.includes('zip'):
        return this.patterns.zip.test(value);
      
      case fieldName.includes('year_established'):
        return this.patterns.year.test(value);
      
      default:
        return true;
    }
  }

  getErrorMessage(field) {
    const value = field.value.trim();
    const type = field.type;
    const required = field.hasAttribute('required');
    const fieldName = field.name;

    // Required field check
    if (required && !value) {
      return this.errorMessages.required;
    }

    // Type-based validation messages
    switch (type) {
      case 'email':
        return this.errorMessages.email;
      
      case 'tel':
        return this.errorMessages.phone;
      
      case 'url':
        return this.errorMessages.url;
      
      case 'number':
        return this.errorMessages.minNumber;
      
      default:
        return this.getSpecialFieldErrorMessage(fieldName);
    }
  }

  getSpecialFieldErrorMessage(fieldName) {
    if (!fieldName) return this.errorMessages.required;

    switch (true) {
      case fieldName.includes('ein'):
        return this.errorMessages.ein;
      
      case fieldName.includes('zip'):
        return this.errorMessages.zip;
      
      case fieldName.includes('year_established'):
        return this.errorMessages.year;
      
      default:
        return this.errorMessages.required;
    }
  }

  showFieldError(field) {
    const fieldId = field.id;
    const errorElement = document.getElementById(`${fieldId}-error`);

    if (errorElement) {
      errorElement.hidden = false;
      errorElement.classList.remove('hidden');
      
      const messageSpan = errorElement.querySelector('span');
      if (messageSpan) {
        messageSpan.textContent = this.getErrorMessage(field);
      }
    }

    field.setAttribute('aria-invalid', 'true');
  }

  clearFieldError(field) {
    const fieldContainer = field.closest('.account-application__field');
    const errorElement = document.getElementById(`${field.id}-error`);
    
    if (errorElement) {
      errorElement.hidden = true;
      errorElement.classList.add('hidden');
    }
    
    fieldContainer?.classList.remove('has-error');
    field.removeAttribute('aria-invalid');
  }

  validateForm() {
    const inputs = this.form.querySelectorAll('.account-application__input');
    let isValid = true;

    inputs.forEach(input => {
      if (!this.validateField(input)) {
        isValid = false;
      }
    });

    return isValid;
  }

  scrollToFirstError() {
    const firstError = this.form.querySelector('.has-error');
    if (firstError) {
      firstError.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      const input = firstError.querySelector('input, textarea');
      if (input) input.focus();
    }
  }

  setLoadingState(loading) {
    const loadingClass = 'account-application--loading';
    
    if (loading) {
      this.form.classList.add(loadingClass);
      this.submitButton.disabled = true;
    } else {
      this.form.classList.remove(loadingClass);
      this.submitButton.disabled = false;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AccountApplicationForm();
});

// Export for potential use in other modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = AccountApplicationForm;
}